import moment from 'moment';

export const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return 'N/A';
  return `$${parseFloat(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatDate = (date, format = 'LL') => {
  if (!date) return 'N/A';
  return moment(date).format(format);
};

export const formatDateTime = (date) => {
  if (!date) return 'N/A';
  return moment(date).format('MMMM DD, YYYY hh:mm A');
};

export const getStatusColor = (status) => {
  const statusColors = {
    'Pending': 'bg-orange-100 text-orange-800',
    'Approved': 'bg-green-100 text-green-800',
    'Rejected': 'bg-red-100 text-red-800',
    'Appealed': 'bg-purple-100 text-purple-800',
    'Transfered': 'bg-blue-100 text-blue-800',
    'Blocked': 'bg-gray-100 text-gray-800'
  };
  return statusColors[status] || 'bg-gray-100 text-gray-800';
};

export const getRiskColor = (riskLevel) => {
  const riskColors = {
    'Low': 'text-green-600 bg-green-50',
    'Medium': 'text-yellow-600 bg-yellow-50',
    'High': 'text-red-600 bg-red-50'
  };
  return riskColors[riskLevel] || 'text-gray-600 bg-gray-50';
};

export const getRiskIcon = (riskLevel) => {
  if (riskLevel === 'Low') return '✓';
  if (riskLevel === 'Medium') return '⚠';
  return '⚠';
};

export const calculateDaysRemaining = (date) => {
  if (!date) return 0;
  const eventDate = moment(date);
  const today = moment();
  return eventDate.diff(today, 'days');
};

export const extractDeductionPercentage = (deductionStr) => {
  if (!deductionStr || deductionStr === "No deduction") return 0;
  
  const match = deductionStr.match(/(\d+)%/);
  console.log("parse",parseInt(match[1]))
  return match ? parseInt(match[1]) : 0;
};

export const calculateRefund = (paidAmount, deductionPercent) => {
  if (!paidAmount || isNaN(paidAmount)) return 0;
  
  const paid = parseFloat(paidAmount);
  const deduction = parseFloat(deductionPercent) / 100;
  const refund = paid - (paid * deduction);
  
  return refund.toFixed(2);
};

export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http')) return imagePath;
  return `${window.$domain || 'https://dash.bestdiplomats.org'}${imagePath}`;
};

export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}...`;
};